const SiteHeader = () => null;

export default SiteHeader;
